module.exports = __webpack_public_path__ + "static/img/logo_DN.7eebfde6.png";